import { mapGetters } from 'vuex';
import { getCookie, setCookie } from '../utils/cookies';
import get from 'lodash/get';

export default {
  methods: {
    get,
    // NOTE @chris Current layout only supports 1 banner, this method is intentionally universal.
    dismissBanner(bannerName) {
      const isConfirmed = confirm('Are you sure?');

      if (!isConfirmed) return;

      setCookie(bannerName, 'true', 365);
      this.hasBannerTaxReturnDelivery = false;
    },
    getBannerDismissed(bannerName) {
      const cookieValue = getCookie(bannerName);
      const isBannerDismissed = cookieValue === 'true';

      return isBannerDismissed;
    },
  },
  data() {
    return {
      hasBannerTaxReturnDelivery: false,
    };
  },
  computed: {
    ...mapGetters({
      currentFirm: 'currentFirm',
      currentUser: 'user',
    }),
    forceDrawSignature() {
      return get(this.currentFirm, 'preferences.force_draw_signature', false);
    },
    forceTypeSignature() {
      return get(this.currentFirm, 'preferences.force_type_signature', false);
    },
    isAdminOrPartner() {
      const isAdminOrPartner =
        this.currentUser &&
        (this.currentUser.firm_access === 'admin' ||
          this.currentUser.firm_access === 'partner');

      return isAdminOrPartner;
    },
    isFirmOnboardingEnabled() {
      return (
        this.isAdminOrPartner &&
        get(this.currentFirm, 'preferences.firm_onboarding_enabled', false)
      );
    },
    signInWithPhoneNumberEnabled() {
      return get(
        this.currentFirm,
        'preferences.sign_in_with_phone_number_enabled',
        false,
      );
    },
    smsCodeVerificationDisabled() {
      return get(
        this.currentFirm,
        'preferences.sms_code_verification_disabled',
        false,
      );
    },
    smsCollectionPopupsDisabled() {
      return get(
        this.currentFirm,
        'preferences.sms_collection_popups_disabled',
        false,
      );
    },
    emailPasscodeDisabled() {
      return get(
        this.currentFirm,
        'preferences.email_passcode_disabled',
        false,
      );
    },
    externalUserIdAllowed() {
      return get(
        this.currentFirm,
        'preferences.external_user_id_allowed',
        false,
      );
    },
    externalEntityIdAllowed() {
      return get(
        this.currentFirm,
        'preferences.external_entity_id_allowed',
        false,
      );
    },
    customStatusesEnabled() {
      return get(
        this.currentFirm,
        'preferences.custom_statuses_enabled',
        false,
      );
    },
    creditUsageEnabled() {
      return get(this.currentFirm, 'preferences.credit_usage_enabled', false);
    },
    signatureRequestsEnabled() {
      return get(
        this.currentFirm,
        'preferences.signature_requests_enabled',
        false,
      );
    },
    deliveryEnabled() {
      return get(
        this.currentFirm,
        'preferences.new_tax_return_delivery_enabled',
        false,
      );
    },
    hideConversationInEmail() {
      return get(
        this.currentFirm,
        'preferences.hide_conversation_in_email',
        false,
      );
    },
    requireOneSignaturePerSection() {
      return get(
        this.currentFirm,
        'preferences.require_one_signature_per_section',
        false,
      );
    },
    documentDropOffEnabled() {
      return get(
        this.currentFirm,
        'preferences.document_drop_off_enabled',
        false,
      );
    },
    hasNewTemplate() {
      return get(this.currentFirm, 'preferences.has_new_template', false);
    },
    hasNewChat() {
      return get(this.currentFirm, 'preferences.has_new_chat', false);
    },
    allActivitiesEnabled() {
      return get(this.currentFirm, 'preferences.all_activities_enabled', false);
    },
    todoTasksEnabled() {
      return get(this.currentFirm, 'preferences.todo_tasks_enabled', false);
    },
    useFirmRoles() {
      return get(this.currentFirm, 'preferences.use_firm_roles', false);
    },
    hasFirmGroups() {
      return get(this.currentFirm, 'preferences.has_firm_groups', false);
    },
    customReportsEnabled() {
      return get(this.currentFirm, 'preferences.custom_reports_enabled', false);
    },
    firmGlossaryEnabled() {
      return get(this.currentFirm, 'preferences.firm_glossary_enabled', false);
    },
    billingEnabled() {
      return get(this.currentFirm, 'preferences.billing_enabled', false);
    },
    customElementEnabled() {
      return get(this.currentFirm, 'preferences.custom_element_enabled', false);
    },
    sorabanConnectEnabled() {
      return (
        get(this.currentFirm, 'preferences.review_and_export_enabled', false) ||
        get(this.currentFirm, 'preferences.return_sync_enabled', false)
      );
    },
    showMultipleRowsInReview() {
      return get(
        this.currentFirm,
        'preferences.show_multiple_rows_in_review',
        false,
      );
    },
    sorabanConnectDemoEnabled() {
      return get(
        this.currentFirm,
        'preferences.soraban_connect_demo_enabled',
        false,
      );
    },
    reviewAndExportEnabled() {
      return get(
        this.currentFirm,
        'preferences.review_and_export_enabled',
        false,
      );
    },
    returnSyncEnabled() {
      return get(this.currentFirm, 'preferences.return_sync_enabled', false);
    },
    defaultAdvancedClient() {
      return get(
        this.currentFirm,
        'preferences.default_advanced_client',
        false,
      );
    },
    firmUserIdleTimeout() {
      return get(this.currentFirm, 'preferences.firm_user_idle_timeout', false);
    },
    clientIdleTimeout() {
      return get(this.currentFirm, 'preferences.client_idle_timeout', false);
    },
    priorYearDocumentsSectionAlias() {
      return get(
        this.currentFirm,
        'preferences.prior_year_documents_section_alias',
        false,
      );
    },
    foreignPreparerDisclosureSectionAlias() {
      return get(
        this.currentFirm,
        'preferences.foreign_preparer_disclosure_section_alias',
        false,
      );
    },
    disableProvidedElsewhere() {
      return get(
        this.currentFirm,
        'preferences.disable_provided_elsewhere',
        false,
      );
    },
    showFilingInstructionsToClients() {
      return get(
        this.currentFirm,
        'preferences.show_filing_instructions_to_clients',
        false,
      );
    },
    newTaxReturnDeliveryEnabled() {
      return get(
        this.currentFirm,
        'preferences.new_tax_return_delivery_enabled',
        false,
      );
    },
    importTaxReturnDraftEnabled() {
      return get(
        this.currentFirm,
        'preferences.import_tax_return_draft_enabled',
        false,
      );
    },
    disableFolderAction() {
      return get(this.currentFirm, 'preferences.disable_folder_action', false);
    },
    allowTaxReturnImport() {
      return get(
        this.currentFirm,
        'preferences.import_tax_return_enabled',
        false,
      );
    },
    savedTaxOrganizer() {
      return get(this.currentFirm, 'preferences.saved_import_method', null);
    },
    allowGroupChanges() {
      return this.currentUser.firm_access === 'partner' && this.hasFirmGroups;
    },
    documentChecklistDialogEnabled() {
      return get(
        this.currentFirm,
        'preferences.document_checklist_dialog_enabled',
        false,
      );
    },
    oldDocumentChecklist() {
      return get(this.currentFirm, 'preferences.old_document_checklist', false);
    },
    bulkUploadProcessor() {
      return get(this.currentFirm, 'preferences.bulk_upload_processor', false);
    },
    documentChecklistPopupEnabled() {
      return get(
        this.currentFirm,
        'preferences.document_checklist_popup_enabled',
        false,
      );
    },
    disableDocumentDumpInRemainingItems() {
      return get(
        this.currentFirm,
        'preferences.disable_document_dump_in_remaining_items',
        false,
      );
    },
    force2FAOnUsers() {
      return get(this.currentFirm, 'preferences.force_2fa_on_users', false);
    },
    force2FAOnFirmUsers() {
      return get(
        this.currentFirm,
        'preferences.force_2fa_on_firm_users',
        false,
      );
    },
    hideDocumentUploadsWithinSections() {
      return get(
        this.currentFirm,
        'preferences.hide_document_uploads_within_sections',
        false,
      );
    },
    showCustomElementFirst() {
      return get(
        this.currentFirm,
        'preferences.show_custom_element_first',
        false,
      );
    },
    defaultCustomElement() {
      return get(this.currentFirm, 'preferences.customElements', null);
    },
    firmSupportEmail() {
      return get(this.currentFirm, 'preferences.support_email', null);
    },
    firmPhoneNumber() {
      return get(this.currentFirm, 'preferences.phone_number', null);
    },
    firmProductGuideDocs() {
      return get(this.currentFirm, 'preferences.product_guide_docs', false);
    },
    questionnaireReminderFrequency() {
      return get(
        this.currentFirm,
        'preferences.questionnaire_reminder_frequency',
        null,
      );
    },
    messageTagsEnabled() {
      return get(this.currentFirm, 'preferences.message_tags_enabled');
    },
    customWelcomeMessage() {
      return get(this.currentFirm, 'preferences.custom_welcome_message', null);
    },
    firmExtensionEmail() {
      return get(this.currentFirm, 'preferences.extension_email', false);
    },
    templateDisabledForNonAdmin() {
      return get(
        this.currentFirm,
        'preferences.template_disabled_for_nonadmin',
        false,
      );
    },
    templateDisabledForFirmGroups() {
      return get(
        this.currentFirm,
        'preferences.template_disabled_for_firm_groups',
        false,
      );
    },
    projectViewEnabled() {
      return get(this.currentFirm, 'preferences.project_view_enabled', false);
    },
    taxReturnDeliveryDefaultSubject() {
      return get(
        this.currentFirm,
        'preferences.tax_return_delivery_default_subject',
        false,
      );
    },
    taxReturnDeliveryDefaultMessage() {
      return get(
        this.currentFirm,
        'preferences.tax_return_delivery_default_message',
        false,
      );
    },
    taxReturnUseNativePdfReaderForClassificationEnabled() {
      return get(
        this.currentFirm,
        'preferences.tax_return_use_native_pdf_reader_for_classification_enabled',
        false,
      );
    },
    taxReturnIdentityVerificationEnabled() {
      return get(
        this.currentFirm,
        'preferences.tax_return_identity_verification_enabled',
        false,
      );
    },
    taxReturnStripeIDVEnabled() {
      return get(
        this.currentFirm,
        'preferences.tax_return_stripe_idv_enabled',
        false,
      );
    },
    taxReturnPaymentEnabled() {
      return get(
        this.currentFirm,
        'preferences.tax_return_payment_enabled',
        false,
      );
    },
    taxReturnPaperFiledReturnsEnabled() {
      return get(
        this.currentFirm,
        'preferences.tax_return_paper_filed_returns_enabled',
        false,
      );
    },
    taxReturnK1DistributionEnabled() {
      return get(
        this.currentFirm,
        'preferences.tax_return_k1_distribution_enabled',
        false,
      );
    },
    taxReturnSendToDocumentsPath() {
      return get(
        this.currentFirm,
        'preferences.tax_return_send_to_documents_path',
        null,
      );
    },
    taxReturnIndividualCustomModelEnabled() {
      return get(
        this.currentFirm,
        'preferences.tax_return_individual_custom_model_enabled',
        false,
      );
    },
    taxReturnBusinessCustomModelEnabled() {
      return get(
        this.currentFirm,
        'preferences.tax_return_business_custom_model_enabled',
        false,
      );
    },
    sendTaxReturnToDocumentsDefaultSubject() {
      return get(
        this.currentFirm,
        'preferences.send_tax_return_to_documents_default_subject',
        false,
      );
    },
    sendTaxReturnToDocumentsDefaultMessage() {
      return get(
        this.currentFirm,
        'preferences.send_tax_return_to_documents_default_message',
        false,
      );
    },
    sharepointIntegrationEnabled() {
      return get(
        this.currentFirm,
        'preferences.sharepoint_integration_enabled',
        false,
      );
    },
    annotationEnabled() {
      return get(this.currentFirm, 'preferences.annotation_enabled', false);
    },
    newQuestionnaireExportEnabled() {
      return get(
        this.currentFirm,
        'preferences.new_questionnaire_export_enabled',
        false,
      );
    },
    questionnaireDocumentNotificationEnabled() {
      return get(
        this.currentFirm,
        'preferences.questionnaire_document_notification_enabled',
        false,
      );
    },
    scanAndAutoFlowExportEnabled() {
      return get(
        this.currentFirm,
        'preferences.scan_and_auto_flow_export_enabled',
        false,
      );
    },
    taxReturnPaymentBeforeSigningEnabled() {
      return get(
        this.currentFirm,
        'preferences.tax_return_payment_before_signing_enabled',
        false,
      );
    },
    newReactAppEnabled() {
      return get(this.currentFirm, 'preferences.new_react_app_enabled', false);
    },
  },
  mounted() {
    const isTaxBannerDismissed = this.getBannerDismissed(
      'has_banner_tax_return_delivery',
    );

    this.hasBannerTaxReturnDelivery = Boolean(
      this.isAdminOrPartner &&
        !isTaxBannerDismissed &&
        get(
          this.currentFirm,
          'preferences.has_banner_tax_return_delivery',
          false,
        ),
    );
  },
};
